export default __webpack_public_path__ + "078ec38566b3a7d7ab9b455fa8439212.png";